var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "home-container" },
    [
      _c(
        "div",
        { staticClass: "hx-breadcrumb" },
        [
          _c(
            "el-breadcrumb",
            { attrs: { "separator-class": "el-icon-arrow-right" } },
            [
              _c("el-breadcrumb-item", [_vm._v("首页")]),
              _c("el-breadcrumb-item", [_vm._v("供应系统")]),
              _c("el-breadcrumb-item", [_vm._v("商品管理")]),
              _c("el-breadcrumb-item", [_vm._v("年货管理")]),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "hx-table-result",
        {
          attrs: { "page-info": _vm.pager, loading: _vm.tableLoading },
          on: {
            "page-current-change": _vm.handleCurrentChange,
            "page-size-change": _vm.handleSizeChange,
          },
        },
        [
          _c("div", { attrs: { slot: "action" }, slot: "action" }),
          _c("hx-table-result-col", [
            _c(
              "div",
              { staticClass: "wrap-table-info-display" },
              [
                _c(
                  "el-button",
                  {
                    staticClass: "align-left",
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.toCreate },
                  },
                  [_vm._v("新增")]
                ),
                _c("span", { staticClass: "table-info-display" }, [
                  _c("span", [_vm._v("总条数：")]),
                  _c("span", { staticClass: "alert-text ft16" }, [
                    _vm._v(_vm._s(_vm.pager.total)),
                  ]),
                ]),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              attrs: { slot: "content", data: _vm.tableData, border: "" },
              slot: "content",
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "bannerName",
                  align: "center",
                  label: "年货名称",
                },
              }),
              _c("el-table-column", {
                attrs: { prop: "imageUrl", align: "center", label: "年货图片" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "table-thumbnail" },
                          [
                            _c("el-image", {
                              attrs: {
                                src: scope.row.imageUrl,
                                fit: "contain",
                                alt: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsName",
                  align: "center",
                  label: "商品名称",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "goodsPicture",
                  align: "center",
                  label: "商品图片",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "table-thumbnail" },
                          [
                            _c("el-image", {
                              attrs: {
                                src: scope.row.goodsPicture,
                                fit: "contain",
                                alt: "",
                              },
                            }),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "是否显示年货",
                  prop: "openBanner",
                  align: "center",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c("el-switch", {
                          attrs: {
                            value: scope.row.status == 1,
                            "active-color": "#13ce66",
                            "inactive-color": "#ff4949",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.statusChange(
                                scope.row.bannerId,
                                scope.row.status
                              )
                            },
                          },
                        }),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { align: "center", label: "操作" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "text" },
                            on: {
                              click: function ($event) {
                                return _vm.editItem(scope.row)
                              },
                            },
                          },
                          [_vm._v("编辑")]
                        ),
                        _c(
                          "confirm-button",
                          {
                            staticStyle: { margin: "0 10px" },
                            attrs: {
                              type: "text",
                              title: "确认要删除该条数据？",
                            },
                            on: {
                              confirmed: function ($event) {
                                return _vm.deleteItem(scope.row.bannerId)
                              },
                            },
                          },
                          [_c("span", [_vm._v("删除")])]
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          staticClass: "hx-to-create-template",
          attrs: {
            title: _vm.dialogTitle,
            visible: _vm.dialogVisible,
            width: "40%",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            close: _vm.resetDialogForm,
          },
        },
        [
          _c(
            "div",
            [
              _c(
                "el-form",
                {
                  ref: "dialogForm",
                  attrs: {
                    model: _vm.itemParams,
                    rules: _vm.checkItemParams,
                    "label-width": "120px",
                  },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "年货名称 ：", prop: "bannerName" } },
                    [
                      _c("el-input", {
                        attrs: { size: "small", placeholder: "请输入年货名称" },
                        model: {
                          value: _vm.itemParams.bannerName,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.itemParams,
                              "bannerName",
                              typeof $$v === "string" ? $$v.trim() : $$v
                            )
                          },
                          expression: "itemParams.bannerName",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "年货图片：", prop: "imageUrl" } },
                    [
                      _c("div", { staticClass: "thumbnail-img" }, [
                        _c("i", {
                          staticClass:
                            "el-icon-circle-plus-outline upload-icon",
                        }),
                        _c("input", {
                          staticClass: "hidden-upload",
                          attrs: { type: "file", id: "uploadDom" },
                          on: { change: _vm.doUpload },
                        }),
                        _vm.itemParams.imageUrl
                          ? _c("img", {
                              staticClass: "thumbnail-img-wrapped",
                              attrs: { src: _vm.itemParams.imageUrl, alt: "" },
                            })
                          : _vm._e(),
                      ]),
                    ]
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "领货日期：" } },
                    [
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "100%" },
                          attrs: {
                            clearable: "",
                            placeholder: "请选择领货日期",
                            size: "small",
                          },
                          on: { change: _vm.dateChange },
                          model: {
                            value: _vm.itemParams.plaSupplyDateId,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemParams, "plaSupplyDateId", $$v)
                            },
                            expression: "itemParams.plaSupplyDateId",
                          },
                        },
                        _vm._l(_vm.dateList, function (item) {
                          return _c("el-option", {
                            key: item.id,
                            attrs: { value: item.id, label: item.title },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: "选择商品 ：", prop: "goodId" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            filterable: "",
                            remote: "",
                            "remote-method": _vm.loadGoodsList,
                            placeholder: "请输入商品名称搜索",
                          },
                          model: {
                            value: _vm.itemParams.goodId,
                            callback: function ($$v) {
                              _vm.$set(_vm.itemParams, "goodId", $$v)
                            },
                            expression: "itemParams.goodId",
                          },
                        },
                        _vm._l(_vm.goodsList, function (item) {
                          return _c("el-option", {
                            key: item.goodId,
                            attrs: { label: item.goodName, value: item.goodId },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    [
                      _c(
                        "el-button",
                        {
                          attrs: {
                            loading: _vm.isDisabled,
                            disabled: _vm.isDisabled,
                            size: "small",
                            type: "primary",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.saveCategoryNameItem("dialogForm")
                            },
                          },
                        },
                        [_vm._v("保 存")]
                      ),
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small" },
                          on: {
                            click: function ($event) {
                              _vm.dialogVisible = false
                            },
                          },
                        },
                        [_vm._v("取 消")]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }